import { helper as buildHelper } from '@ember/component/helper';
export default buildHelper(function (params) {
  let arr = params[0];
  return Array.isArray(arr) ? arr[0] : arr;
});
